import React from 'react';

interface ItalicProps {
    children: React.ReactNode;
}

const Italic: React.FC<ItalicProps> = ({ children }) => <em>{children}</em>;

export default Italic;
